import { useContext } from 'react';
import { CounterContext } from '../contexts/counter';

export function useCounterContext() {
  const context = useContext(CounterContext);
  if (context === undefined) {
    throw new Error('useCounter must be used within a CounterProvider');
  }
  return context;
}
